import { render, staticRenderFns } from "./productCategoriesModal.vue?vue&type=template&id=418f7a6f&"
import script from "./productCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./productCategoriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports